import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

export default function RevealOnScroll({
  children,
  className,
  style,
  variants,
  viewportAmount = 0.18,
  once = true,
  ...props
}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  const defaultVariants = {
    hidden: { opacity: 0, y: 28, scale: 0.995 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  const used = variants || defaultVariants;

  useEffect(() => {
    if (!ref.current) return;

    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      // eslint-disable-next-line no-console
      console.log('RevealOnScroll: IO not available, showing immediately', className);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry && entry.isIntersecting) {
          setInView(true);
          // eslint-disable-next-line no-console
          console.log('RevealOnScroll: entered viewport', className);
          if (once) observer.disconnect();
        } else if (!once) {
          setInView(false);
        }
      },
      { threshold: viewportAmount }
    );

    observer.observe(ref.current);

    return () => {
      try { observer.disconnect(); } catch (e) { /* ignore */ }
    };
  }, [viewportAmount, once, className]);

  // Important: keep la etiqueta section (layout) y animar un contenedor interior
  return (
    <section ref={ref} className={className} style={style} {...props}>
      <motion.div
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={used}
        style={{ willChange: 'transform, opacity' }}
      >
        {children}
      </motion.div>
    </section>
  );
}